export const NODE_ENV = window.env.NODE_ENV || 'development';
// It was just easy to add this than mock on tests
export const ORIGIN = window?.location?.origin || '';
export const GRAPHQL_URL = '/graphql';
export const GRAPHQL_SUBSCRIPTIONS_URL = `${ORIGIN.replace('http', 'ws').replace('3033', '3000')}/subscriptions`;
export const LOCAL_STORAGE_KEY_LANGUAGE = 'swipeguide_language_selection';
export const SWIPE_TRACKER_URL = window.env.SWIPE_TRACKER_URL || '';
export const SWIPE_TRACKER_X_API_KEY = window.env.SWIPE_TRACKER_X_API_KEY || '';
export const SENTRY_DSN_VIEWERS = window.env.SENTRY_DSN_VIEWERS || '';
export const SENTRY_DSN_CMS = window.env.SENTRY_DSN_CMS || '';
export const SENTRY_AUTH_TOKEN = window.env.SENTRY_AUTH_TOKEN || '';
export const SENTRY_RELEASE = process.env.SENTRY_RELEASE || '';
export const GIT_COMMIT_SHA = process.env.GIT_COMMIT_SHA || '';
// The default RECAPTCHA_SITE_KEY is the default test key. See: https://developers.google.com/recaptcha/docs/faq
export const RECAPTCHA_SITE_KEY = window.env.RECAPTCHA_SITE_KEY || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
export const BUILD_TIMESTAMP = window.env.BUILD_TIMESTAMP || 0;
export const BUILD_VERSION = window.env.BUILD_VERSION || '';
export const DEFAULT_LOCALE = 'en_US';
export const termsAndConditionsUrl = 'https://swipeguide.com/terms-and-conditions';
export const INVALID_CREDENTIALS_ERRORS = ['user_not_found', 'invalid_password', 'attempt_5th_invalid_password'];
export const LOCKED_ACCOUNT_STATUS_CODE = 429;
export const INVALID_LOGIN_OPTION_CODE = 'INVALID_LOGIN_OPTION';
export const LOCAL_STORAGE_KEY_SORT_BY = 'swipeguide_sort_by_preference';
export const CLOUDINARY_API_KEY = window.env.CLOUDINARY_API_KEY || '468587893643718';
export const CLOUDINARY_API_PRC_PROXY_HOSTNAME = window.env.CLOUDINARY_API_PRC_PROXY_HOSTNAME;
export const CLOUDINARY_CDN_HOSTNAME = window.env.CLOUDINARY_CDN_HOSTNAME || 'res.cloudinary.com';
export const CLOUDINARY_API_HOSTNAME = window.env.CLOUDINARY_API_HOSTNAME || 'api.cloudinary.com';
export const CLOUDINARY_URL = window.env.CLOUDINARY_URL || `https://${CLOUDINARY_API_HOSTNAME}/v1_1/swipe-dev/upload`;
// The largest source video Cloudinary transforms during the upload itself: 40MB on free accounts, 300MB on paid.
export const CLOUDINARY_SYNC_VIDEO_LIMIT_MB = Number(window.env.CLOUDINARY_SYNC_VIDEO_LIMIT_MB) || 40;
export const POSTHOG_API_KEY = window.env.POSTHOG_API_KEY;
// Manages the Development Feature Flags
export const FEATURE_FLAGS_API_URL = 'https://h1p6t0nta3.execute-api.eu-west-1.amazonaws.com/api-flags';
export const UNLEASH_ENABLED = typeof window.env.UNLEASH_ENABLED !== 'undefined' ? window.env.UNLEASH_ENABLED : true;
export const UNLEASH_URL = window.env.UNLEASH_URL || 'https://flags.swipeguide.com/api/frontend';
export const UNLEASH_CLIENT_KEY =
  window.env.UNLEASH_CLIENT_KEY || 'default:development.3b35a9d9d4baa962e3a80f0720ea1a5914769728dff2837a596e1129';

export const UNLEASH_APP_NAME = 'swipeguide flags';
export const UNLEASH_BOOTSTRAP_DEV_FEATURE_FLAGS = [
  {
    name: 'checklistScoring',
    enabled: true
  },
  {
    name: 'skillTags',
    enabled: true
  },
  {
    name: 'learningActivityTags',
    enabled: true
  },
  {
    name: 'activityLogLinking',
    enabled: true
  },
  {
    name: 'contactMethodSelection',
    enabled: false
  },
  {
    name: 'dispatch',
    enabled: false
  },
  {
    name: 'skillBasedMatrix',
    enabled: false
  },
  {
    name: 'assessmentCriteria',
    enabled: true
  },
  {
    name: 'nestedLists',
    enabled: false
  },
  {
    name: 'checklistExtraField',
    enabled: false
  },
  {
    name: 'feedbackSidebar',
    enabled: false
  },
  {
    name: 'mandatoryProofOfAssessment',
    enabled: true
  },
  {
    name: 'skillDescriptionField',
    enabled: true
  },
  {
    name: 'skillsTranslations',
    enabled: false
  }
];
// Cookie preference settings
export const COOKIE_PREFERENCE_NAME = 'sg_accept_stats_cookies';
export const COOKIE_PREFERENCE_MAX_AGE = 365 * 24 * 60 * 60 * 1000; // 12 months
export const PRIVACY_POLICY_VERSION = '1';
export const PRIVACY_POLICY_URL = 'https://www.l2l.com/privacy-policy';

export const emailValidationRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const helpArticleURL = 'https://support.leading2lean.com/hc/en-us';

// Userpilot
export const USERPILOT_TOKEN = window.env.USERPILOT_TOKEN;
export const USERPILOT_APPLICATION_NAME = window.env.USERPILOT_MOBILE_APPLICATION_NAME || 'SwipeGuide';

export const SUPERSET_BASE_URL = window.env.SUPERSET_BASE_URL;

export const DATE_TIME_FORMAT = 'l LT';

export const CHECKLIST_EXTRA_FIELD_VALUE_MAX_LENGTH = 50;
